module.exports = __webpack_public_path__ + "fonts/font.1bd51d0b.woff";